import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import Button from "react-bootstrap-button-loader";
import { Modal } from "react-bootstrap";
import { COMMON_FAIL_MESSAGE } from "Constants";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { showError, showSuccess } from "ReduxErrorBar";
import { fetchAllUnpublishedCourses } from "CourseAction";
import { openChapterModal, updateChapter } from "CourseAction";
import LocaleStrings from "Languages";

class AddChapter extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount() {}

  closeModal = () => {
    this.props.openChapterModal({ showModal: false });
    this.setState({ loading: false });
  };

  onSubmitForm = (data) => {
    let { session, editMode } = this.props;
    
    var courseid = data.courseid;
    var values = { ...data };



    this.setState({ loading: true });
    if (editMode) {
      // Update.....
      this.props.updateChapter(session, values, (responose) => {
        this.setState({ loading: false });
        if (responose.success) {
          this.props.finishOperationsCallback();
          this.props.fetchAllUnpublishedCourses(session, courseid);
          this.props.showSuccess(LocaleStrings.course_chapter_update_success);
          this.closeModal();
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      });
    } else {
      // Insert.....
    }
  };

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      chapterModal,
      editMode,
    } = this.props;

    return (
      <div>
        <Modal
          className="modal-container"
          show={chapterModal && chapterModal.showModal === true ? true : false}
          animation={true}
          keyboard={false}
          backdrop="static"
        >
          <Modal.Header>
            <div className="import-modal-title">
              {editMode ? LocaleStrings.edit : LocaleStrings.add}{" "}
              {LocaleStrings.chapter}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <form onSubmit={handleSubmit(this.onSubmitForm)}>
            <Modal.Body>
              <div>
                <AddChapterForm {...this.props} />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-custom-white"
                onClick={this.closeModal}
              >
                {LocaleStrings.button_close}
              </Button>
              <Button
                className="btn btn-custom-blue ml-10"
                loading={this.state.loading}
                disabled={pristine || invalid || submitting}
                type="submit"
              >
                {LocaleStrings.button_save}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let edit = false;
  var initVals = {};
  var chapters = [];

  if (
    state.chapterModal &&
    state.chapterModal.chapterData &&
    state.chapterModal.chapterData.chapterid
  ) {
    edit = true;
    initVals = state.chapterModal.chapterData;
  }

  if (
    state.allUnpublishedCourseList &&
    state.allUnpublishedCourseList.count > 0
  ) {
    chapters = _.sortBy(
      state.allUnpublishedCourseList.resource[0].course_chapter_by_courseid,
      ["ranking", "createdon"]
    );
  }

  return {
    session: state.session,
    editMode: edit,
    initialValues: initVals,
    chapterModal: state.chapterModal,
    chapters,
  };
}

function validate(values, ownProps) {
  var errors = {};
  var chaptername = values["chaptername"];

  if (!chaptername || chaptername.trim() === "") {
    errors["chaptername"] =
      LocaleStrings.course_chapter_form_validation_required;
  } else if (
    chaptername &&
    chaptername != ownProps.initialValues.chaptername &&
    _.filter(ownProps.chapters, (obj) => {
      return obj.chaptername == chaptername;
    }).length > 0
  ) {
    errors["chaptername"] =
      LocaleStrings.course_chapter_form_validation_chapter_already_exist;
  }

  return errors;
}

export default connect(mapStateToProps, {
  openChapterModal,
  updateChapter,
  fetchAllUnpublishedCourses,
  showError,
  showSuccess,
})(
  reduxForm({
    validate,
    form: "ChapterForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(AddChapter)
);

class AddChapterForm extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="basicform">
        <Field
          name="chaptername"
          label={LocaleStrings.course_chapter_form_label_chapter_name}
          placeholder={LocaleStrings.course_chapter_form_ph_chapter_name}
          type="text"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
        />
      </div>
    );
  }
}
